import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { db } from '../../firebase';
import { collectionGroup, query, where, onSnapshot } from 'firebase/firestore';

const MessageNotifier = () => {
  const user = useSelector((state) => state.auth.user);
  const [toasts, setToasts] = useState([]);
  const ready = useRef(false);

  useEffect(() => {
    if (!user?.uid) return;
    ready.current = false;

    const q = query(
      collectionGroup(db, 'messages'),
      where('to', '==', user.uid),
      where('read', '==', false)
    );

    const unsubscribe = onSnapshot(q, (snap) => {
      // Первый снимок после загрузки/входа — НЕ показываем старые непрочитанные
      if (!ready.current) {
        ready.current = true;
        return;
      }
      // Дальше реагируем ТОЛЬКО на новые сообщения
      snap.docChanges().forEach((change) => {
        if (change.type !== 'added') return;
        const msg = change.doc.data();
        if (msg.from === user.uid) return;
        const name = msg.fromName || msg.fromEmail || 'Сообщение';
        const id = change.doc.id;
        setToasts((t) => [...t, { id, text: `💬 ${name}: ${msg.text || '📎 файл'}` }]);
        setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 6000);
      });
    });

    return () => unsubscribe();
  }, [user?.uid]);

  if (toasts.length === 0) return null;

  return (
    <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 2000, display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {toasts.map((t) => (
        <div key={t.id} style={{ background: '#1e3c72', color: '#fff', padding: '10px 14px', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.3)', fontSize: '13px', maxWidth: '300px' }}>
          {t.text}
        </div>
      ))}
    </div>
  );
};

export default MessageNotifier;